import { RowSectorDto } from "@/dtos";
import { Sector } from "@/entities";

export const formatRowSectorDto = (sectors: Sector[]): RowSectorDto[] => {

    return sectors.map(x => {
        const row: RowSectorDto = {
            ...x,
            company: x.details?.name,
            active: x.is_active ? 'Activo' : 'Inactivo',
            maxLimitLabel: x.maxLimit + " Km/h"
        }
        
        return row;
    });
}